import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  ModalClose,
  ModalDialog,
  Typography,
} from "@mui/joy";
import { TaskStatus } from "griptonite-api-client/types/tasks";

import { Task } from "@/core/types";
import { useOptimisticTaskUpdateMutation } from "@/hooks/tasks";
import { useCurrentVenueUuid } from "@/hooks/venues";

import { getStatusLabel } from "../TaskCard/StatusChip";
import { useModal } from "./useModal";

export default function ConfirmUncompleteSettingTask({
  status,
  task,
}: {
  status: TaskStatus;
  task: Task;
}) {
  const { close } = useModal();
  const venueUuid = useCurrentVenueUuid();
  const mutation = useOptimisticTaskUpdateMutation(venueUuid);
  const mutate = mutation.mutate;

  return (
    <ModalDialog>
      <ModalClose />
      <DialogTitle>Are you sure?</DialogTitle>
      <DialogContent>
        <Typography sx={{ maxWidth: 350 }}>
          Moving this task to <strong>{getStatusLabel(status)}</strong> will unpublish the route,
          making it hidden from users. Are you sure you want to do this?
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button
          color="danger"
          onClick={() => {
            mutate({
              task,
              payload: { status },
            });
            close();
          }}
          sx={{ flex: 1 }}
        >
          Continue
        </Button>
        <Button color="neutral" variant="soft" onClick={close} sx={{ flex: 1 }}>
          Cancel
        </Button>
      </DialogActions>
    </ModalDialog>
  );
}
